import { OptionItem } from '../../diagram/utils/option-item';
import { VideoType } from '../../../view-data/components/video/video-type';
var VideoTypeHelper = /** @class */ (function () {
    function VideoTypeHelper() {
    }
    VideoTypeHelper.getVideoTypes = function () {
        return [
            new OptionItem(VideoType.Ezviz, 'Ezviz'),
            new OptionItem(VideoType.LeChange, 'LeChange')
        ];
    };
    VideoTypeHelper.getVideoTypeName = function (videoType) {
        switch (videoType) {
            case VideoType.Ezviz:
                return 'Ezviz';
            case VideoType.LeChange:
                return 'LeChange';
            default:
                return '';
        }
    };
    return VideoTypeHelper;
}());
export { VideoTypeHelper };
